<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12">
      @if (loading) {
        <div class="loading-indicator">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }
      @if (!loading) {
        <div class="ui-g card mt-4">
          <div class="event-activity">
            <div class="sbhd">Number of Events Requiring Action</div>
            <div class="p-grid">
              <div
                class="p-col-12 p-md-6 p-lg-4 p-xl-3"
                *ngFor="let queue of $any(engagementCountModel)">
                <div class="queue-tile event-panel">
                  <div>{{ queue.queueName }} {{ queueTitle }}</div>
                  <div class="queue-count">{{ queue.pendingReviewCount }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
